<template lang="pug">
  #membership.admin.theme-1
    section.material-half-bg
      .cover
    section.membership-form
      .modal(tabindex="-1" style="position: relative; display: block;", v-if="state.matches('initializing.working')")
        .modal-dialog.modal-sm.modal-dialog-centered
          .modal-content
            .modal-body
              | Initializing. . .
              i.m-0.fa.fa-spin.fa-circle-notch.float-right
      .modal(tabindex="-1" style="position: relative; display: block;", v-if="state.matches('initializing.failure')")
        .modal-dialog.modal-dialog-centered
          .modal-content
            .modal-header
              h1.modal-title.text-center
                i.fa.fa-exclamation-circle.text-danger
                |&nbsp;Oops!
            .modal-body
              p There was an error while initializing form for membership. Please click <a href="javascript:void(0)" @click.prevent="send('WORKING');">here</a> to try again.
      div(v-else-if="!state.matches('initializing')")
        .dropdown
          button.btn.btn-sm.btn-dark.dropdown-toggle(type="button" v-if="isDev" data-toggle="dropdown")
            i.fa.fa-cog
          .dropdown-menu(style="z-index: 9999;")
            a.dropdown-item(href="javascript:void(0)" @click.prevent="testData()") Generate data
        .modal(tabindex="-1" style="position: relative; display: block;")
          .modal-dialog.modal-lg
            .modal-content
              .modal-header.d-flex.justify-content-center
                div
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 1, 'badge-primary': state.matches('step_1')}") Confirmatory
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 2, 'badge-primary': state.matches('step_2')}") Personal Details
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 3, 'badge-primary': state.matches('step_3')}") Emergency Contact
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 4, 'badge-primary': state.matches('step_4')}") Products and Services
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 5, 'badge-primary': state.matches('step_5')}") Terms and consent
                //- .btn-group.btn-sm
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 1, 'btn-primary': state.matches('step_1')}") Step 1
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 2, 'btn-primary': state.matches('step_2')}") Step 2
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 3, 'btn-primary': state.matches('step_3')}") Step 3
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 4, 'btn-primary': state.matches('step_4')}") Step 4
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 5, 'btn-primary': state.matches('step_5')}") Step 5
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 6, 'btn-primary': state.matches('step_6')}") Step 6
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 7, 'btn-primary': state.matches('step_7')}") Step 7
              .modal-body
                .row
                  .col-12(v-show="state.matches('step_1')")
                    step_1(ref="Step1Cmpt"
                      v-model="confirmatoryField"
                      @next="send('NEXT')")
                  .col-12(v-show="state.matches('step_2')")
                    step_2(ref="Step2Cmpt"
                      v-model="personalDetailField"
                      :coops="state.context.coops",
                      :memberships="state.context.memberships"
                      @prev="send('PREV')", @next="send('NEXT')")
                  .col-12(v-show="state.matches('step_3')")
                    step_3(ref="Step3Cmpt"
                      v-model="emergencyContactField"
                      @prev="send('PREV')", @next="send('NEXT')")
                  .col-12(v-show="state.matches('step_4')")
                    step_4(ref="Step4Cmpt"
                      v-model="packagesField"
                      @prev="send('PREV')",
                      @next="send('NEXT')")
                  .col-12(v-show="state.matches('step_5')")
                    step_5(ref="Step5Cmpt"
                      v-model="consentField"
                      @prev="send('PREV')")
                  //- .col-12(v-show="state.matches('step_6')")
                    step_6
                  //- .col-12(v-show="state.matches('step_7')")
                    step_7
              .modal-footer.d-flex.justify-content-between
                button.btn.btn-secondary(type="button", :disabled="state.matches('step_1')" @click.prevent="send('PREV')") Previous
                button.btn.btn-primary(type="button", v-if="['step_1', 'step_2', 'step_3', 'step_4'].some(state.matches)" @click.prevent="send('NEXT')") Next
                button.btn.btn-primary(type="button", :disabled="!state.matches('step_5.valid')" v-if="state.matches('step_5')" @click.prevent="send('SUBMIT')") SUBMIT
</template>

<style scoped="">
  .cursor-pointer {
    cursor: pointer;
  }
</style>
<script>
  import faker from 'faker'
  import { ref, reactive, onMounted } from '@vue/composition-api'
  import { createMachine } from 'xstate'
  import { useMachine } from 'xstate-vue2'
  const Machine = createMachine(require('./index.state').default)

  export default {

    name: 'membership',
    components: {
      'step_1': require('./components/step_1.vue').default,
      'step_2': require('./components/step_2.vue').default,
      'step_3': require('./components/step_3.vue').default,
      'step_4': require('./components/step_4.vue').default,
      'step_5': require('./components/step_5.vue').default,
      'step_6': require('./components/step_6.vue').default,
      'step_7': require('./components/step_7.vue').default,
    },

    setup (props, {emit, root}) {
      const isDev = ref(process.env.NODE_ENV==='development')
      const Step1Cmpt = ref(null)
      const Step2Cmpt = ref(null)
      const Step3Cmpt = ref(null)
      const Step4Cmpt = ref(null)
      const Step5Cmpt = ref(null)
      const consentField = reactive({
        picture: null,
        validId: null,
        picWithId: null,
        readsConsent: false,
        authorized: false,
      })
      const confirmatoryField = ref(false)
      let packagesField = ref([])
      const emergencyContactField = reactive({
        contactPerson: '',
        contactNumber: '',
        beneficiary1: '',
        beneficiary2: '',
        beneficiary3: ''
      })
      let personalDetailField = reactive({
        preferredBranch: '',
        membership: '',
        lastName: '',
        firstName: '',
        middleName: '',
        civilStatus: '',
        sex: '',
        dateOfBirth: '',
        placeOfBirth: '',
        age: '',
        emailAddress: '',
        mobileNumber: '',
        socialContact: '',
        socialContactType: '',
        permanentAddress: '',
        presentAddress: '',
        ownedHouse: '',
        yearsOfResidence: '',
        educationalAttainment: '',
        religion: '',
        nationality: '',
        occupation: '',
        monthlyIncome: '',
        validID: '',
        IDNumber: '',
      })
      const { $swal, $store, _router } = root
      const { send, state } = useMachine(Machine, {
        guards: {},
        actions: {
          /**
           * [success description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          success(ctx, event) {
            $swal({
              icon: 'success',
              title: 'Success!',
              text: 'Your membership was successfully sent. Please wait up to 3 to 5 days and be notified',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then(result => {
              _router.replace({name: 'login'})
            })
          },
          /**
           * [failure description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          failure(ctx, event) {
            console.log('event', event);
            $swal({
              icon: 'error',
              title: 'Oops!',
              text: 'Something wen\'t wrong. Please try again later.',
              allowOutsideClick: false
            })
          },
          /**
           * [validationError description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validationError(ctx, event) {
            $swal({
              icon: 'error',
              title: 'Validation Error!',
              text: 'Please complete the form fields.',
              allowOutsideClick: false
            })
          }
        },
        services: {
          /**
           * [fetching description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          fetching(ctx, event) {
            return Promise.all([$store.dispatch('coop/getCoops'), $store.dispatch('membership/get_types')])
          },
          /**
           * [validateStep1 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep1(ctx, event) {
            return Step1Cmpt.value.validate()
            // return Promise.resolve(true)
          },
          /**
           * [validateStep2 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep2(ctx, event) {
            return Step2Cmpt.value.validate()
          },
          /**
           * [validateStep3 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep3(ctx, event) {
            return Step3Cmpt.value.validate()
            // return Promise.resolve(true)
          },
          /**
           * [validateStep4 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep4(ctx, event) {
            return Step4Cmpt.value.validate()
          },
          /**
           * [validateStep5 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep5(ctx, event) {
            return Step5Cmpt.value.validate()
          },
          // /**
          //  * [validateStep6 description]
          //  * @param  {[type]} ctx   [description]
          //  * @param  {[type]} event [description]
          //  * @return {[type]}       [description]
          //  */
          // validateStep6(ctx, event) {
          //   return Promise.resolve(true)
          // },
          // /**
          //  * [validateStep7 description]
          //  * @param  {[type]} ctx   [description]
          //  * @param  {[type]} event [description]
          //  * @return {[type]}       [description]
          //  */
          // validateStep7(ctx, event) {
          //   return Promise.resolve(true)
          // }
          submitting(ctx, event) {
            $swal({
              text: 'Sending. . .',
              allowOutsideClick: false,
              allowEscapeKey: false
            })
            $swal.showLoading()
            const payload = new FormData()
            Object.keys(consentField).forEach((key) => {
              payload.append('consent['+key+']', consentField[key])
            })
            packagesField.value.forEach((value, index) => {
              payload.append('packages['+index+']', value)
            })
            Object.keys(emergencyContactField).forEach((key) => {
              payload.append('emergencyContact['+key+']', emergencyContactField[key])
            })
            Object.keys(personalDetailField).forEach((key) => {
              payload.append('information['+key+']', personalDetailField[key])
            })
            return $store.dispatch('membership/apply', payload)
            // return new Promise((resolve, reject) => {
            //   setTimeout(() => {
            //     resolve(true);
            //   }, 5000)
            // })
          }
        }
      })
      onMounted(() => {

      })
      const testData = () => {
        console.log('Generate test data.')
        confirmatoryField.value = true
        personalDetailField.preferredBranch = faker.random.arrayElement(state.value.context.coops).id
        personalDetailField.memberships = faker.random.arrayElement(state.value.context.memberships).id
        personalDetailField.lastName = faker.name.lastName()
        personalDetailField.firstName =faker.name.firstName()
        personalDetailField.middleName = faker.name.lastName()
        personalDetailField.civilStatus = faker.random.arrayElement(['SINGLE', 'MARRIED', 'WIDOWED/WINDOWER'])
        personalDetailField.sex = faker.random.arrayElement(['MALE', 'FEMALE', 'OTHER'])
        personalDetailField.dateOfBirth = faker.date.past()
        personalDetailField.placeOfBirth = faker.lorem.sentence()
        personalDetailField.age = faker.datatype.number({min: 18, max: 60})
        personalDetailField.emailAddress = faker.internet.email()
        personalDetailField.mobileNumber = '0'+faker.datatype.number({min: 1000000000, max: 9999999999})
        personalDetailField.socialContact = faker.datatype.number({min: 100000, max: 999999})
        personalDetailField.socialContactType = ''
        personalDetailField.permanentAddress = faker.address.streetAddress()
        personalDetailField.presentAddress = faker.address.streetAddress()
        personalDetailField.ownedHouse = faker.random.arrayElement(['OWNED', 'RENTED', 'LIVING_WITH_PARENT'])
        personalDetailField.yearsOfResidence = faker.datatype.number({min: 1, max: 10})
        personalDetailField.educationalAttainment = faker.random.arrayElement([
          'SCHOOL_LESS_1_YEAR',
          'ELEMENTARY_GRADUATE',
          'HIGH_SCHOOL_GRADUATE',
          'COLLEGE_UNDERGRADUATE',
          'BACHELOR_DEGREE',
          'MATERS_DEGREE',
          'PROFESSIONAL',
        ])
        personalDetailField.religion = faker.lorem.sentence()
        personalDetailField.nationality = faker.address.country()
        personalDetailField.occupation = faker.random.arrayElement([
          'GOVERNMENT',
          'PRIVATE',
          'ENTERPRENEUR',
          'FARMER',
          'FISHERFOLKS',
          'PENSIONER',
          'SELF_EMPLOYED',
          'STUDENT',
          'NOT_YET_IN_SCHOOL',
          'OFW',
          'NONE'
        ])
        personalDetailField.monthlyIncome = faker.random.arrayElement([
          '5K_BELOW',
          '5K_10K',
          '10K_15K',
          '15K_30K',
          '30K_ABOVE'
        ])
        personalDetailField.validID = faker.random.arrayElement([
          'DRIVER_LICENSE',
          'UMID',
          'PAGIBIG',
          'PRC_ID',
          'COMPANY_ID'
        ])
        personalDetailField.IDNumber = faker.datatype.number({min: 1000000, max: 9999999})

        emergencyContactField.contactPerson = faker.name.firstName() +' '+ faker.name.lastName()
        emergencyContactField.contactNumber = '0'+faker.datatype.number({min: 1000000000, max: 9999999999})
        emergencyContactField.beneficiary1 = faker.name.firstName() +' '+ faker.name.lastName()
        emergencyContactField.beneficiary2 = faker.name.firstName() +' '+ faker.name.lastName()
        emergencyContactField.beneficiary3 = faker.name.firstName() +' '+ faker.name.lastName()

        packagesField.value = faker.random.arrayElements([
          'PINOY_KOOP_ATM_SERVICE',
          'KAYA_PAYMENT_PLATFORM',
          'MMC_MOBILE_APPLICATION',
          'INSURANCE_(AKSI,GLAFFLETC)'
        ], faker.datatype.number({min: 1, max: 4}))

        consentField.authorized = true
        consentField.readsConsent = true
      }
      return {
        isDev,
        confirmatoryField,
        personalDetailField,
        emergencyContactField,
        packagesField,
        consentField,

        send, state,

        Step1Cmpt, Step2Cmpt, Step3Cmpt, Step4Cmpt, Step5Cmpt,

        testData
      }
    }
  }
</script>

<style lang="css" scoped>
</style>